module.exports = __webpack_public_path__ + "assets/img/115@3x.0932f297.png";